import script from "./ModelRunnerHome.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelRunnerHome.vue?vue&type=script&setup=true&lang=js"

import "./ModelRunnerHome.vue?vue&type=style&index=0&id=ec0665a8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec0665a8"]])

export default __exports__